import React, { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#F3EFE7]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14 lg:mb-16">
          <Reveal><Overline className="mb-6">{t.faq.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1A1A1A]">
              {t.faq.title}
            </h2>
          </Reveal>
        </div>

        <div className="divide-y divide-[#1A1A1A]/12 border-y border-[#1A1A1A]/12">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div data-testid={`faq-item-${i}`} itemScope itemType="https://schema.org/Question">
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  >
                    <span itemProp="name" className="font-display text-xl sm:text-2xl font-medium text-[#1A1A1A] group-hover:text-[#B0926A] transition-colors">
                      {item.q}
                    </span>
                    <Plus
                      size={22}
                      className={`flex-shrink-0 text-[#B0926A] transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
                        className="overflow-hidden"
                        itemScope
                        itemType="https://schema.org/Answer"
                      >
                        <p itemProp="text" className="pb-7 pr-10 text-[#4A4A4A] text-base font-light leading-relaxed max-w-3xl">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
